module.exports = __webpack_public_path__ + "img/new-york-pizza.81fd4d87.png";